import reduce from './reduce'

export default {
  reduce
}



// WEBPACK FOOTER //
// ./src/data/api/aggregation/index.js